import { render, staticRenderFns } from "./dataLibrary.vue?vue&type=template&id=15940086&scoped=true&"
import script from "./dataLibrary.vue?vue&type=script&lang=js&"
export * from "./dataLibrary.vue?vue&type=script&lang=js&"
import style0 from "./dataLibrary.vue?vue&type=style&index=0&id=15940086&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15940086",
  null
  
)

export default component.exports